import React from "react";
import "./BlogButton.css";

const Button = React.forwardRef(
  ({ className = "", variant = "default", size = "default", ...props }, ref) => {
    return (
      <button
        className={`btn-custom ${variant} ${size} ${className}`}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = "BlogButton";

export { Button };
